import { Component, OnInit } from '@angular/core';
import { MessageService } from 'app/services/message.service';
import {NgbAlert} from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent implements OnInit {
  staticAlert: NgbAlert;
  constructor(public messageService: MessageService) { }

  ngOnInit() {
  }

}




// WEBPACK FOOTER //
// /app/src/app/modules/login/messages/messages.component.ts